export default {
  tips: {
    areaNoPermission:
      'Playturboの動画および画像制作サービスは、お住まいの国/地域では利用できません。',
  },
  useless: '使用できません',
}
